<template>
  <div class="pivo-auth">
    <div class="user-panel">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  }
};
</script>

<style lang="less" scoped>
body {
  overflow: hidden;
  box-sizing: border-box;
  margin: 0;
}

.pivo-auth {
  .user-panel {
    position: relative;
    max-width: 400px;
    margin: 100px auto;
  }
}
</style>
